class MapCollabClient {

  constructor({access, config}) {
    if (!window) {
      throw new Error("Must be called from browser");
    }
  }

  isOpen() {
    return true;
  }

  send(obj) {
    if (obj.type === 'operation') {
      return Promise.resolve({ status: 'success' });
    }
  }

  setHandler(type, handler) {
  }

  sendOperationReceivedMessage({ operationId }) {
  }

}

module.exports = MapCollabClient;



// WEBPACK FOOTER //
// ./starling/src/lib/map_collab_client_noop.js